import {
  AutopilotTaskDto,
  TaskCategoryStage,
  TaskCategoryWorkflowType,
} from '@urbanx/agx.activities.client';

export enum TaskTabs {
  Tasks = 'Tasks',
  Deposits = 'Deposits',
  Other = 'Other',
}

export const getTaskTabForTask = (task: AutopilotTaskDto): TaskTabs => {
  const { category, contractId } = task;

  if (contractId && category?.stage === TaskCategoryStage.Deposits) {
    return TaskTabs.Deposits;
  }

  if (
    category?.workflowType === TaskCategoryWorkflowType.IndependentCampaign ||
    category?.workflowType === TaskCategoryWorkflowType.IndependentContract
  ) {
    return TaskTabs.Other;
  }

  if (category?.workflowType === TaskCategoryWorkflowType.Deposit) {
    return TaskTabs.Deposits;
  }

  return TaskTabs.Tasks;
};
